import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { RequestStatus } from '../../../../enums/RequestStatusEnum';

const InvoiceEditAmountModal = ({ showAmountModal, handleAmountModalClose, handleAmountChange, amount, editInvoiceData, setShowAmountModal, invoices, fetchInvoices }) => {
    const { t } = useTranslation();
    const [isRequestButtonDisabled, setIsRequestButtonDisabled] = useState({});
    const [amountValue, setAmountValue] = useState("");
    const [isEditInvoiceCreated, setIsEditInvoiceCreated] = useState(false);
    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState(false);
    const [isEditCreditInvoiceAccept, setIsEditCreditInvoiceAccept] = useState(false);
     const [isRequestApproved, setIsRequestApproved] = useState(false);
     const [amountError, setAmountError] = useState("");
     const [isApiLoading, setIsApiLoading] = useState(false);

    useEffect(() => {
        if (editInvoiceData) {
            setAmountValue(editInvoiceData.amountIncVat || "");
        }
    }, [editInvoiceData]);

    useEffect(() => {
        const fetchInvoiceEditData = async () => {
            try {
                const response = await axios.get(`/InvoiceEdit/${editInvoiceData.invoiceNumber}?requestType=${RequestStatus.Credit}`);
                const data = response.data;
                setIsRequestApproved(data.isRequestApproved);
                const amountData = data.invoiceEditItems[0]?.requestedValue;
                const userComment = data.invoiceEditItems[0]?.userComment;
                setIsEditInvoiceCreated(data.isEditInvoiceCreated);
                if (amountData) {
                    setAmountValue(amountData);
                } else {
                    setAmountValue(editInvoiceData.amountIncVat || "");
                }
                if (userComment) {
                    setDescription(userComment);
                }
                setIsEditCreditInvoiceAccept(data.isAnyResponseOnEditCreditInvoice);
            } catch (error) {
                toast.error(t("An error occurred while fetching invoice edit data. Please try again."));
            }
        };

        if (editInvoiceData && editInvoiceData.id) {
            fetchInvoiceEditData();
        }
    }, [editInvoiceData, t]);

    const handleInputChange = (e) => {
        const { value } = e.target;
        handleAmountChange(e);
        setAmountValue(value);
        setAmountError("");
    };

    const handleRequestButtonClick = async () => {
        if (!description.trim()) {
            setDescriptionError(true);
            return;
        }
        setDescriptionError(false);
       
        if (parseFloat(amountValue) > parseFloat(editInvoiceData.amountIncVat)) {
            setAmountError(t("Amount should not be greater than the original invoice amount."));
            return;
        }
        setAmountError("");

        setIsApiLoading(true); // Start loading

        try {
            const requestBody = {
                invoiceId: editInvoiceData.id,
                    id: 0,
     requestedBy: 0,
     requestStatus: 0,
     requestType: 1,
     isEditInvoiceCreated: false,
     isAnyResponseOnEditCreditInvoice: false,
     isRequestApproved: null,
                invoiceEditItems: [
                    {userComment: description,
                         fieldName: "UserComment",
      requestedValue: "",
      originValue: "",
      approvedBy: null,
      actualAmount: null
                     }
                ],
            };
            await axios.post(`/CreditInvoice`, requestBody);
            toast.success(t("The Credit Note request has been sent successfully.") + " " + `#${editInvoiceData.invoiceNumber}`);
            setShowAmountModal(false);
            setIsRequestButtonDisabled(prevState => ({ ...prevState, [editInvoiceData.id]: true }));
            fetchInvoices();
        } catch (error) {
            toast.error(t("An error occurred while requesting edits. Please try again."));
        } finally {
            setIsApiLoading(false); // Stop loading
        }
    };

    return (
        <div>
            <Modal show={showAmountModal} onHide={handleAmountModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Credit Note")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3" style={{ fontWeight: "bold" }}>
                        {t("Please confirm if you want to request credit invoice for this invoice?")}
                    </div>
                    <Form>
                        <Form.Group controlId="formDescription" className="mt-3">
                            <Form.Label>{t("Description")}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder={t("Enter description")}
                                isInvalid={descriptionError}
                                style={{ margin: "0" }}
                            />
                            {descriptionError && (
                                <Form.Text className="text-danger">
                                    {t("Description is required.")}
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAmountModalClose}>
                        {isEditInvoiceCreated ? t("Close") : t("Cancel")}
                    </Button>
                    {isEditCreditInvoiceAccept ? (
                        <Button variant={isRequestApproved ? "success" : "danger"} disabled>
                            {t(isRequestApproved ? "Approved" : "Declined")}
                        </Button>
                    ) : isEditInvoiceCreated ? (
                        <Button variant="primary" disabled>
                            {t("Already Requested")}
                        </Button>
                    ) : (
                        // YES button replaces Request Credit Note button
                        <Button
                            variant="primary"
                            onClick={handleRequestButtonClick}
                            disabled={
                                isRequestButtonDisabled[editInvoiceData.id] ||
                                !description.trim() ||
                                isApiLoading
                            }
                        >
                            {isApiLoading ? t("Processing...") : t("Yes")}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default InvoiceEditAmountModal;